var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useCurrentPersonInfo from "../../Hooks/useCurrentPersonInfo";
import ServiceResult from "../ServiceResult/ServiceResult";
/**
 * Shows a loading indicator while permissions like those accessed by useHasPermission are loaded onto the front-end
 * Intended to avoid flashes in the UI.
 *
 */
const PermissionBoundary = (_a) => {
    var { children } = _a, otherProps = __rest(_a, ["children"]);
    // We use useCurrentPersonInfo to fetch permissions.  When currentPersonInfo is loaded, the permissions are also loaded
    const personState = useCurrentPersonInfo();
    return (
    // Show a loading indicator or error while permissions are being loaded
    _jsx(ServiceResult, Object.assign({}, otherProps, { state: personState, children: children })));
};
export default PermissionBoundary;
